import { render, staticRenderFns } from "./MatchDetailScheduleSection.vue?vue&type=template&id=3ac04dc5&scoped=true"
import script from "./MatchDetailScheduleSection.vue?vue&type=script&lang=js"
export * from "./MatchDetailScheduleSection.vue?vue&type=script&lang=js"
import style0 from "./MatchDetailScheduleSection.vue?vue&type=style&index=0&id=3ac04dc5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac04dc5",
  null
  
)

export default component.exports